import React from "react";
import { ButtonStyled } from "./Button.styled";

/**
 * A customizable button component with multiple styles, sizes, and variants.
 *
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to display on the button.
 * @param {JSX.Element} [props.icon] - Optional icon to display alongside the text.
 * @param {function} props.onClick - Function to call when the button is clicked.
 * @param {string} [props.type="button"] - The HTML type attribute of the button. Defaults to "button".
 * @param {boolean} [props.dark=false] - If true, the button color will be lighter if there is a dark background
 * @param {boolean} [props.disabled=false] - If true, the button will be disabled and not interactable.
 * @param {'primary' | 'secondary' | 'tertiary' | 'warning' | 'link'} [props.variant="primary"] - The button color scheme. Defaults to "primary".
 * @param {'large' | 'medium' | 'small'} [props.size="medium"] - The size of the button. Defaults to "medium".
 * @param {'row' | 'row-reverse' | 'column' | 'column-reverse'} [props.direction="row"] - The flex-direction of the button contents. Defaults to "row".
 * @param {object} [props.style={}] - Additional inline styles to apply to the button.
 */
export const Button = ({
  text,
  icon,
  onClick,
  dark = false,
  light = false,
  type = "button",
  disabled = false,
  variant = "primary",
  size = "medium",
  direction = "row",
  style = {},
  ...rest
}) => {
  return (
    <ButtonStyled
      type={type}
      dark={dark}
      light={light}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      size={size}
      direction={direction}
      style={style}
      {...rest}
    >
      {icon ? icon : null} {text ? <span>{text}</span> : null}
    </ButtonStyled>
  );
};
